import { Button } from '@sunwebgroup/uds-ui/button'
import { ListItem } from '@sunwebgroup/uds-ui/list-item'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import * as React from 'react'
import { useIntl } from '@/intl'
import {
  FilterableCarsAvailable,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable'
import {
  carToBeSelected,
  showingExtraCars,
  useCarRentalFilteringServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import styles from './ExtraCarsView.module.css'

export function ExtraCarsView({ maxNumbersOfCarsToBeBooked }: { maxNumbersOfCarsToBeBooked: number }) {
  const intl = useIntl()
  const { service } = useService(ServiceType.CarRentalFiltering)
  const { setShowExtraCars } = useCarRentalFilteringServiceStore()
  const isShowingExtraCars = useCarRentalFilteringServiceStore(showingExtraCars)
  const selectingCar = useCarRentalFilteringServiceStore(carToBeSelected)

  if (maxNumbersOfCarsToBeBooked <= 1)
    return null
  if (!service)
    return null
  const { options } = service
  const selectingCarOption = selectingCar ? options?.[selectingCar] : null

  return (
    <Sheet.Root
      open={isShowingExtraCars}
      onOpenChange={(open) => {
        setShowExtraCars(open)
      }}
    >
      {!selectingCarOption && (
        <Sheet.Trigger>
          <ListItem variant="outlined" className={styles.addExtraCarsContentButton}>
            <Button onClick={() => setShowExtraCars(true)} variant="secondary">
              {intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_extra_cars_add_button' })}
            </Button>
          </ListItem>
        </Sheet.Trigger>
      )}

      <Sheet.Body side="bottom" hasPadding={false}>
        <Sheet.Header
          titleLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_title' })}
          closeLabel={intl.formatMessage({
            id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_close_text',
          })}
        />
        <FilterableCarsAvailable />
      </Sheet.Body>
    </Sheet.Root>
  )
}
